/**
 * Append API fields to FormData for multipart POST/PATCH.
 * Skips null/undefined — FormData would otherwise send the literal string "null".
 *
 * @param {FormData} formData
 * @param {Object} fields
 */
export function appendFieldsToFormData(formData, fields) {
  if (!formData || !fields || typeof fields !== 'object') {
    return;
  }
  Object.keys(fields).forEach(key => {
    const value = fields[key];
    if (value === null || value === undefined) {
      return;
    }
    formData.append(key, value);
  });
}
